

export const useErrorLogging = () => {
  //const { enqueueSnackbar } = useSnackbar();

  const logError = (message: string, error?: any) => {
    console.error(message, error);
    
    /*
    enqueueSnackbar(message, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
    });
    */
  };


  return { logError };
};
